<div class="flex"
     style="gap: 16px;">
    <form-mui-field class="block pos-relative _search w-6"
                    [label]="('Town, Postcode, Area'| translate)"
                    [hideSideIcon]="true">
        <input type="text"
               name="address"
               #addressInput
               [attr.placeholder]="'Town, Postcode, Area' | translate"
               (keyup.enter)="search()"
               required
               [(ngModel)]="address" />
    </form-mui-field>
    <button [status]="confirmStatus"
            [buttonStyle]="'button'"
            [disabled]="!selectedBranch?.data?.branch_number"
            class="w-6"
            (click)="confirm()">{{'Confirm' | translate}}</button>
</div>
<div class="flex flex-middle m-t col-3">
    <i class="icon-geo-direction"></i>
    <button [inlineButton]
            [status]="locationStatus"
            (click)="loadCurrentLocation()"
            class="s2 m-l-1">{{'Use my current location' | translate}}</button>
</div>
<result [status]="status"></result>
<result [status]="confirmStatus"></result>
<result [status]="locationStatus"></result>
<div class="m-t-2">
    @for (store of findableModels; track store.id) {
    <div class="cursor-pointer flex flex-middle p-t-2 p-b-2">
        <branch-finder-item [store]="store"
                            [distance]="store.data?.distance"
                            (click)="selectBranch(store)"
                            [stockQty]="getQty(store)"
                            [selected]="selectedBranch?.id === store.id"
                            [disabled]="isDisabled(store)"
                            class="block flex-grow"></branch-finder-item>
    </div>
    }
</div>
